module.exports = __webpack_public_path__ + "img/clap.ea6d3b5d.png";